import RpcService           from '@/core/services/Rpc/RpcService';
import type RpcResponse     from '@/core/services/Rpc/RpcResponse';
import type TradeMark       from '@/domains/TradeMarks/TradeMark';
import type RpcDataPagination from '@/core/services/Rpc/RpcDataPagination';
import type RpcDataSort       from '@/core/services/Rpc/RpcDataSort';


class TradeMarksDAO {

	static async get(id: number): Promise<RpcResponse> {
		return await RpcService.makeRequest('tradeMarks.get', { id });
	}

	static async getList(
		filters?: {
			pattern?: string;
		},
		pagination?: RpcDataPagination,
		sort?:       RpcDataSort,
	): Promise<RpcResponse> {
		return await RpcService.makeRequest('tradeMarks.getList', filters, pagination, sort);
	}

	static async update(tradeMark: TradeMark): Promise<RpcResponse> {
		return await RpcService.makeRequest('tradeMarks.update', { tradeMark });
	}
}

export default TradeMarksDAO;